import angular from 'angular';

export class MainController {
  menuItems = [];
  leftNavFullWidth = false;

  /*@ngInject*/
  constructor($scope, $http, $state, $transitions, Auth, pageSettings,
              $log) {
    const vm = this;
    this.$http = $http;
    this.$state = $state;
    this.Auth = Auth;
    this.pageSettings = pageSettings;
    this.$transitions = $transitions;

    Auth.getCurrentUser()
      .then(data => {
        this.currentUser = data;
      });

    vm.init = () => {
      this.menuItems = [
        {
          slug: 'separator'
        },
        // {
        //   icon: "home",
        //   name: "Pulpit",
        //   state: "main.home",
        //   stateOptions: {location: true, inherit:true, notify:false}
        // },
        // {
        //   slug: "separator"
        // },
        {
          icon: 'business',
          name: 'Ubezpieczenia',
          state: 'main.insuranceOffers'

        },
        {
          icon: 'credit_card',
          name: 'Karty Lotos',
          state: 'main.lotosCards'

        },
        {
          icon: 'email',
          name: 'Prośby o kontakt - sport',
          state: 'main.subscribeList'

        },
        // {
        //   name: "Kalkulacje",
        //   icon: 'event_note',
        //   state: "main.calucations",
        // },
      ];


    };
  }

  $onInit() {
    this.init();
  }


  logout() {
    this.$state.go('logout');
  }

  changePassword() {
    this.$state.go('main.settings');
  }

  toggleNav() {
    this.leftNavFullWidth = !this.leftNavFullWidth;
  }


}

export default angular.module('ngOskCrmApp.mainLogged', [])
  .component('main', {
    template: require('./main.pug'),
    controller: MainController,
    controllerAs: 'vm'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/main/main.component.js